import { Directive, ElementRef, inject } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';

import { InAppBrowserService } from 'src/app/@core/in-app-browser.service';
import { objectFromUrlParams } from 'src/app/@shared/utils';

@Directive({
  selector: '[handle-links]',
  standalone: false,
})
export class HandleLinksDirective {
  private element = inject(ElementRef);
  private inAppBrowserService = inject(InAppBrowserService);
  private navController = inject(NavController);
  private platform = inject(Platform);

  public ngOnInit(): void {
    this.element.nativeElement.addEventListener('click', this.onElementClicked.bind(this));
  }

  private onElementClicked(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();

    const elem = ev.target as HTMLElement;

    if (!elem) { return; }
    if (elem.tagName.toUpperCase() !== 'A') { return; }

    let url = elem.getAttribute('href');

    if (!url) { return; }

    if (url.startsWith('http') || url.startsWith('mailto') || url.startsWith('tel')) {
      this.handleExternalLink(url);

      return;
    }

    const [, urlParams] = url.split('?');

    // eslint-disable-next-line prefer-destructuring
    url = url.split('?')[0];

    let queryParams = {};

    if (urlParams) {
      queryParams = objectFromUrlParams(urlParams);
    }

    this.navController.navigateForward(url, {
      queryParams,
    }).catch();
  }

  private handleExternalLink(url: string): void {
    if (url.includes('tel:') || url.includes('mailto:')) {
      if (this.platform.is('android')) {
        window.open(url, '_system');

        return;
      }

      window.location.href = url;

      return;
    }

    this.inAppBrowserService.openUrl(url);
  }
}
